import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAllPackages } from "../../api/apiPackages";
import parseError from "../../utils/parseError";

const useRestoreAllPackages = () => {
    const queryClient = useQueryClient();

    const {
        mutate: restoreAllPkg,
        isPending: isRestoreAll,
    } = useMutation({
        mutationFn: restoreAllPackages,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["packages"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore packages");
        },
    });

    return {
        restoreAllPkg,
        isRestoreAll,
    };
};

export default useRestoreAllPackages;
